import { render, staticRenderFns } from "./bannerSwipe.vue?vue&type=template&id=2b5e6dcb&scoped=true&"
import script from "./bannerSwipe.vue?vue&type=script&lang=js&"
export * from "./bannerSwipe.vue?vue&type=script&lang=js&"
import style0 from "./bannerSwipe.vue?vue&type=style&index=0&id=2b5e6dcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e6dcb",
  null
  
)

export default component.exports